// Typelizer digest 87fe3c76733e432677c979efdeb53db8
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/purchase_orders/:purchase_order_id/preview */
  show: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/preview', params, options),
    method: 'get',
  }),

  /** POST /c/:company_id/purchase_orders/:purchase_order_id/preview */
  create: (
    params: { purchaseOrderId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/purchase_orders/:purchase_order_id/preview', params, options),
    method: 'post',
  }),
}
